const analyseChilds = [
  {
    path: "statistics",
    name: "analyseStatistics",
    component: () => import("@/views/analyse/statistics.vue"),
    children: [
      {
        path: "scenic",
        name: "analyseScenic",
        component: () => import("@/views/analyse/children/scenic.vue"),
      },
      {
        path: "store",
        name: "analyseStore",
        component: () => import("@/views/analyse/children/store.vue"),
      },
      {
        path: "agent",
        name: "analyseAgent",
        component: () => import("@/views/analyse/children/agent.vue"),
      },
      {
        path: "activity",
        name: "analyseActivity",
        component: () => import("@/views/analyse/children/activity.vue"),
      },
      {
        path: "hotel",
        name: "analyseHotel",
        component: () => import("@/views/analyse/children/hotel.vue"),
      },
    ],
  },
];
export default analyseChilds;
